import React from "react";
import Link from "next/link";
import Image from "next/image";
import Button from "@/components/actions/Button";
import * as Text from "@/components/text";
import { getStrapiImage } from "@/utils/strapiFunctions";

export default function ScreeningCard({
  projection,
  formatOptions,
  today,
  weekDays,
  allProjections,
}) {
  return (
    <>
      <hr className="h-0.5 w-full bg-black"></hr>
      <div className="flex w-full sm:flex-col sm:py-8 lg:flex-row lg:py-16">
        <div className="pr-11 sm:w-full sm:pb-6 lg:w-[280px] lg:pb-0">
          <div className="flex items-center">
            <h2 className="text-4xl font-bold">
              {new Date(
                projection?.attributes?.tv_screenings?.[0]?.date
              ).toLocaleDateString("es-ES", formatOptions)}
            </h2>
            {new Date(
              projection?.attributes?.tv_screenings?.[0]?.date
            ).toLocaleDateString("en-us", { month: "short", day: "numeric" }) ==
              today.toLocaleDateString("en-us", {
                month: "short",
                day: "numeric",
              }) ? (
              <div className="ml-3 h-fit rounded-full bg-black px-4 py-1.5 text-xs text-white">
                Hoy
              </div>
            ) : null}
          </div>
          <Text.Noun>
            {
              weekDays[
              new Date(
                projection?.attributes?.tv_screenings?.[0]?.date
              ).getDay()
              ]
            }
          </Text.Noun>
        </div>
        <div className="grid w-full sm:grid-flow-row md:grid-cols-2 ">
          <div
            className="flex w-full sm:flex-row"
            id={new Date(
              projection?.attributes?.tv_screenings?.[0]?.date
            ).toLocaleDateString("es-ES", formatOptions)}
          >
            <Image
              alt="screening image"
              height={1080}
              width={720}
              className="object-cover sm:mr-2 sm:h-[152px] sm:w-[96px] md:mr-6 md:h-[216px] md:w-[144px]"
              src={
                getStrapiImage(
                  projection?.attributes?.peliculas?.data[0]?.attributes
                    ?.film_cover_image,
                  "small"
                )
              }
            />
            <div>
              <div className="w-fit rounded-full bg-neutral-200 px-2 py-0.5 text-xs font-[600]">
                Transmisión
              </div>
              <Text.Title className="mb-1 pr-2 text-xl font-bold sm:hidden md:flex">
                {new Date(projection?.attributes?.tv_screenings?.[0]?.date)
                  .getHours()
                  .toString()
                  .padStart(2, "0")}
                :
                {new Date(projection?.attributes?.tv_screenings?.[0]?.date)
                  .getMinutes()
                  .toString()
                  .padStart(2, "0")}&nbsp;
                hrs
              </Text.Title>
              <Text.Title className="mb-0.5 text-xl text-neutral-400 sm:hidden md:flex">
                CST
              </Text.Title>
              <Text.Title className="text-xl font-semibold leading-[26px]">
                {projection?.attributes?.title}
              </Text.Title>
              <div>
                <Text.Label className="py-1 text-sm font-semibold">
                  {
                    projection?.attributes?.peliculas?.data?.[0]?.attributes
                      ?.Directores?.[0]?.Director
                  }
                </Text.Label>
              </div>
              <div className="flex py-1 text-sm">
                <Text.Label>
                  {
                    projection?.attributes?.peliculas?.data?.[0]?.attributes
                      ?.film_length
                  }
                  &apos;
                </Text.Label>
                <div className="mx-1 text-neutral-400">|</div>
                <Text.Label>
                  {
                    projection?.attributes?.peliculas?.data?.[0]?.attributes
                      ?.film_year?.[0]?.year
                  }
                </Text.Label>
                <div className="mx-1 text-neutral-400">|</div>
                {projection?.attributes?.peliculas?.data?.[0]?.attributes?.countries.map(
                  (country) => (
                    <>
                      <Text.Label className="pr-1" key={country.id}>
                        {country.countries}&nbsp;
                      </Text.Label>
                      <div className="mx-1 text-neutral-400">|</div>
                    </>
                  )
                )}
              </div>
              <Text.Label className="sm:hidden md:flex">
                {projection?.attributes?.tv_screenings?.[0]?.tv_channel}
              </Text.Label>
              <div className="flex items-center">
                {projection?.attributes?.peliculas?.data[0]?.attributes
                  .film_trailer_link && (
                    <Link
                      target="_blank"
                      href={
                        projection?.attributes?.peliculas?.data[0]?.attributes
                          ?.film_trailer_link
                      }
                      passHref
                    >
                      <Button
                        color="terciary-light"
                        size="md"
                        className="my-4 mr-2 w-[87px]"
                        label="Ver trailer"
                      ></Button>
                    </Link>
                  )}
                {projection?.attributes?.peliculas?.data[0]?.attributes
                  ?.filmSlug && (
                    <Link
                      target="_blank"
                      href={
                        "/catalogo/" +
                        projection?.attributes?.peliculas?.data[0]?.attributes
                          ?.filmSlug
                      }
                      passHref
                    >
                      <Button
                        color="secondary-light"
                        size="md"
                        className="my-4 w-fit"
                        label="Ver detalles"
                      ></Button>
                    </Link>
                  )}
              </div>
            </div>
          </div>
          {allProjections.map((sameDayProjection, i) => (
            <>
              {new Date(
                sameDayProjection?.attributes?.tv_screenings?.[0]?.date
              ).toLocaleDateString() ===
                new Date(
                  projection?.attributes?.tv_screenings?.[0]?.date
                ).toLocaleDateString() && i > 0 ? (
                <div className="flex w-full sm:flex-row">
                  <Image
                    alt="screening image"
                    height={1080}
                    width={720}
                    className="object-cover sm:mr-2 sm:h-[152px] sm:w-[96px] md:mr-6 md:h-[216px] md:w-[144px]"
                    src={
                      getStrapiImage(
                        sameDayProjection?.attributes?.peliculas?.data[0]
                          ?.attributes?.film_cover_image,
                        "small"
                      )
                    }
                  />
                  <div>
                    <div className="w-fit rounded-full bg-neutral-200 px-2 py-0.5 text-xs font-[600]">
                      Transmisión
                    </div>
                    <Text.Title className="pr-2 text-xl font-bold sm:hidden md:flex">
                      {new Date(
                        sameDayProjection?.attributes?.tv_screenings?.[0]?.date
                      )
                        .getHours()
                        .toString()
                        .padStart(2, "0")}
                      :
                      {new Date(
                        sameDayProjection?.attributes?.tv_screenings?.[0]?.date
                      )
                        .getMinutes()
                        .toString()
                        .padStart(2, "0")}&nbsp;
                      hrs
                    </Text.Title>
                    <Text.Title className="text-xl text-neutral-400 sm:hidden md:flex">
                      CST
                    </Text.Title>
                    <Text.Title className="text-xl font-semibold leading-[26px]">
                      {sameDayProjection?.attributes?.title}
                    </Text.Title>
                    <div>
                      <Text.Label className="py-1 text-sm font-semibold">
                        {
                          sameDayProjection?.attributes?.peliculas?.data?.[0]
                            ?.attributes?.Directores?.[0]?.Director
                        }
                      </Text.Label>
                    </div>
                    <div className="flex py-1 text-sm">
                      <Text.Label>
                        {
                          sameDayProjection?.attributes?.peliculas?.data?.[0]
                            ?.attributes?.film_length
                        }
                        &apos;
                      </Text.Label>
                      <div className="mx-1 text-neutral-400">|</div>
                      <Text.Label>
                        {
                          sameDayProjection?.attributes?.peliculas?.data?.[0]
                            ?.attributes?.film_year?.[0]?.year
                        }
                      </Text.Label>
                      <div className="mx-1 text-neutral-400">|</div>
                      {sameDayProjection?.attributes?.peliculas?.data?.[0]?.attributes?.countries.map(
                        (country) => (
                          <>
                            <Text.Label className="pr-1" key={country.id}>
                              {country.countries}&nbsp;
                            </Text.Label>
                            <div className="mx-1 text-neutral-400">|</div>
                          </>
                        )
                      )}
                    </div>
                    <Text.Label className="sm:hidden md:flex">
                      {
                        sameDayProjection?.attributes?.tv_screenings?.[0]
                          ?.tv_channel
                      }
                    </Text.Label>
                    <div className="flex items-center">
                      {sameDayProjection?.attributes?.peliculas?.data[0]
                        ?.attributes.film_trailer_link && (
                          <Link
                            target="_blank"
                            href={
                              sameDayProjection?.attributes?.peliculas?.data[0]
                                ?.attributes?.film_trailer_link
                            }
                            passHref
                          >
                            <Button
                              color="terciary-light"
                              size="md"
                              className="my-4 mr-2 w-[87px]"
                              label="Ver trailer"
                            ></Button>
                          </Link>
                        )}
                      {sameDayProjection?.attributes?.peliculas?.data[0]
                        ?.attributes?.filmSlug && (
                          <Link
                            target="_blank"
                            href={
                              "/catalogo/" +
                              sameDayProjection?.attributes?.peliculas?.data[0]
                                ?.attributes?.filmSlug
                            }
                            passHref
                          >
                            <Button
                              color="secondary-light"
                              size="md"
                              className="my-4 w-fit"
                              label="Ver detalles"
                            ></Button>
                          </Link>
                        )}
                    </div>
                  </div>
                </div>
              ) : null}
            </>
          ))}
        </div>
      </div>
    </>
  );
}
